import { RoleInterface } from "../RoleInterface";
import { Role } from "../Role";
import Translator from "../../../../../Translation/Translator";

class Occupant extends Role implements RoleInterface  {

  public static contactRoleId: number = 7;

  public getName(): string {
    return Translator.trans("role-occupant");
  }

}

export { Occupant }
